import { useSelector, useDispatch } from "react-redux";
import { getReactionUsers } from "../../../../services/chats/frontend-chats";
import { GetAuthUserLocalStorage } from "../../../../services/localStorage/localStorage";
import { sortReactions } from "../../../../utils/reactions";

const ReactionDisplay = ({ message, chatId, onReactionUserClick }) => {
  const dispatch = useDispatch();
  const authUser = GetAuthUserLocalStorage();

  if (!message.reactions) {
    return null;
  }

  const sortedReactions = sortReactions(message.reactions);
  const validReactions = Object.keys(sortedReactions).filter(
    (emoji) => sortedReactions[emoji].count > 0,
  );

  if (validReactions.length === 0) {
    return null;
  }

  const handleReactionClick = async (emoji) => {
    try {
      const users = await getReactionUsers(
        message.thread_id,
        chatId,
        emoji,
        dispatch,
      );
      if (onReactionUserClick) {
        onReactionUserClick(emoji, users, message.thread_id);
      }
    } catch (error) {
      console.error("Error fetching reaction users:", error);
    }
  };

  const isUserReacted = (emoji) => {
    return sortedReactions[emoji]?.users?.[authUser?.id] === true;
  };

  return (
    <div className="message-reactions">
      {validReactions.map((emoji) => (
        <div
          key={emoji}
          className={`reaction-chip ${isUserReacted(emoji) ? "user-reacted" : ""}`}
          onClick={() => handleReactionClick(emoji)}
        >
          <span className="reaction-emoji">{emoji}</span>
          <span className="reaction-count">{sortedReactions[emoji].count}</span>
        </div>
      ))}
    </div>
  );
};

export default ReactionDisplay;
